<template>
  <div class="wrapper">
    <div class="order-element">
      <div class="tag">
        <span class="order_state"></span>
      </div>
      <div class="order-id" :class="{'red': obj.info.overdueDays  > 0 }" v-text="`ID: ${obj.info.orderNo}`"></div>
      <ul class="order-info-list">
        <li class="oi-element red" v-if="obj.info.overdueDays > 0 ">
          <span class="left">Days Overdue</span>
          <span class="right" v-text="`${obj.info.overdueDays}`"></span>
        </li>
        <li class="oi-element red"  v-if="obj.info.overdueDays  > 0">
          <span class="left">Overdue Fees</span>
          <span class="right" v-text="`₹ ${obj.info.overdueFee}`"></span>
        </li>
        <li class="oi-element">
          <span class="left">Product Name</span>
          <span class="right" v-text="`${obj.info.productName}`"></span>
        </li>
        <li class="oi-element">
          <span class="left">Loan Amount</span>
          <span class="right" v-text="`₹ ${obj.info.loanAmount}`"></span>
        </li>
        <li class="oi-element">
          <span class="left">Tenure</span>
          <span class="right" v-text="`${obj.info.period} days`"></span>
        </li>
        <li class="oi-element">
          <span class="left">Received</span>
          <span class="right" v-text="`₹ ${obj.info.arriveAmount}`"></span>
        </li>
        <li class="oi-element">
          <span class="left">Repayment Amount</span>
          <span class="right" v-text="`₹ ${obj.info.repaymentAmount}`"></span>
        </li>
      </ul>
    </div>
    <div class="detail-info">
      <ul class="detail-list">
        <li class="detail-list-element">
          <span class="left-text">Processing Fee</span
          ><span class="right-text" v-text="`₹${obj.info.processFee}`"></span>
        </li>
        <li class="detail-list-element">
          <span class="left-text">GST18% on Processing Fee</span
          ><span class="right-text" v-text="`₹${obj.info.gstFee}`"></span>
        </li>
        <li class="detail-list-element">
          <span class="left-text">Interest Fee</span
          ><span class="right-text" v-text="`₹${obj.info.interestFee}`"></span>
        </li>
        <li class="detail-list-element"><span class="left-text">Application Date</span><span class="right-text" v-text="obj.info.applyTime"></span></li>
      </ul>    
    </div>
    <div class="extension-msg" v-show="obj.info.isExtension">
        <router-link :to="`/orders/${obj.info.id}/extension`">Repayment stress? <strong>Extend due date</strong></router-link> 
    </div>
    <div class="placeholder"></div>
    <div class="btn-container">
        <a class="btn-submit" :class='{"red": obj.info.overdueDays  > 0}' @click.prevent="submit" v-text="`Repayment ₹ ${obj.info.repaymentAmount}`"></a>
    </div>
    
    <!-- <div class="dialog-confirm" v-show="dialog_confirm_show">
      <div class="dialog">
        <div class="dialog-head">
          <i class="icon icon-close" @click="submit"></i>
        </div>
        <div class="dialog-content">
          <p class="dc-caption">When the loan is repaid, do you need assistance to automatically apply for a new loan ?</p>
          <div class="checkbox-container" @click="obj.checked = !obj.checked">
              <i class="icon" :class="{'icon-check': obj.checked, 'icon-uncheck': !obj.checked}"></i>
              <p class="label-caption">
                 Help me apply for a loan automatically next time. 
              </p>
          </div>
          <div class="expect-amount" v-show="obj.checked" @click="showAmountList">
              <div class="left-content">
                  <h4 class="oi-title">Loan Amount</h4>    
                  <div class="oi-content" :class="{'no-choice': !obj.reapply.selectAmount}" v-text="obj.reapply.selectAmount? obj.reapply.selectAmount : 'Click To Select Amount'"></div>
              </div>
              <div class="right-content">
                  <i class="icon" :class='{"icon-arrow-up":list_show, "icon-arrow-right":!list_show}'></i>
              </div>              
              <ul class="amount-list" v-show='list_show'>
                  <li class="amount-element" @click.prevent="selected($event, ind)" :class="{'active': ind === selected_ind}" v-for="(ele, ind) in obj.reapply.amountList" :key="ind" v-text="ele"></li>
              </ul>
          </div>
          <div class="bank" v-show="obj.checked" @click="showBankList">
              <div class="left-content">
                  <h4 class="oi-title">Bank Account</h4>
                  <div class="oi-content" :class="{'no-choice': !bank_info.have_bank}" v-text="bank_info.have_bank? bank_info.card_no : 'Click To Select Bankcard'"></div>                        
              </div>
              <div class="right-content">
                  <i class="icon" :class='{"icon-arrow-up":bank_list_show, "icon-arrow-right":!bank_list_show}'></i>
              </div>
              <ul class="bank-list" v-show='bank_list_show'>
                  <li class="bank-element" @click.prevent="selectedBank($event, ind)" :class="{'active': ind === selected_ind}" v-for="(ele, ind) in bank_info.list" :key="ind" v-text="ele.cardNo"></li>
              </ul>
          </div>
          <div class="btn-group">
            <div class="btn-submit" @click="beforeSubmit">Confirm</div>
          </div>
          <p class="alert">
            You can cancel a scheduled order within 2 hours of settling the order in the <strong>scheduled order list</strong>.
          </p>
        </div>      
      </div>
    </div> -->

  </div>
</template>
<style lang="less" scoped>
.placeholder{
  height:180px;
}

.extension-msg{
  color:#999;
  text-align: center;
  padding:50px 30px;
  font-size: 24px;
  a{
    color:#999;
    strong{
      color:#444898
    }
  }
}
.wrapper {
  padding-top: 50px;
  .alert{
    margin:30px 0;
    line-height: 1.5;
    color:#5febf3;
    font-size: 28px;
    text-align: center;
    strong{
      font-weight: 700;
    }
  }
  .bank-list{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background:rgba(255,255,255,1);
        border-radius: 15px;;
        z-index: 99999;
        padding:0 30px;
        top:310px;
        border:1px solid #5febf3;
        .bank-element{
            text-align:center;
            // width: 150px;
            padding:30px;
            color:#A59BB3;
            font-size: 28px;   
            border-bottom: 2px solid #e0e0e0;   
            &:last-child{
                border-bottom: none;
            }      
            &:hover{
                color:#5febf3;
                border-bottom-color:#e0e0e0;   
            }
        }
        
    }
  .amount-list{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background:rgba(255,255,255,1);
        border-radius: 15px;;
        z-index: 99999;
        padding:0 30px;
        top:10px;
        border:1px solid #5febf3;
        .amount-element{
            text-align:center;
            width: 150px;
            padding:30px;
            color:#A59BB3;
            font-size: 28px;   
            border-bottom: 2px solid #e0e0e0;   
            &:last-child{
                border-bottom: none;
            }      
            &:hover{
                color:#5febf3;
                border-bottom-color:#e0e0e0;   
            }
        }
        
    }
  .dialog-confirm{            
      top:0;
      left:0;
      bottom:0;
      right:0;
      background:rgba(0,0,0,0.7);
      position: fixed;
      z-index:5;
      .dialog{
        width: 590px;
        border-radius: 20px;
        padding:40px;
        background:#fff;
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        .btn-group{
          .btn-submit{
            width: 590px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            font-size: 36px;
            color:#fff;
            background: #5febf3;
            border-radius: 20px;
          }
        }
        .dc-caption{
          font-size: 28px;
          color:#151515;
          word-break: break-all;
          line-height: 1.5;
        }
        .dialog-head{
          position: relative;
          height: 10px;
          .icon{
            position: absolute;
            top:-35px;
            right:-35px;
          }
        }
        // .expect-amount{
        //   .top-content-inner{
        //     display: flex;
        //     justify-content: space-between;
        //     align-items: center;
        //     .tci-amount{
        //       font-size: 36px;
        //       color:#151515;
        //       flex:1 0 auto;
        //       span{
        //         font-weight: 700;
        //         font-size: 40px;
        //       }
        //     }
        //     .icon{
        //       flex:0 0 auto;
        //     }
        //   }
        // }
        .expect-amount{
           display: flex;
           align-items: center;
           justify-content: space-around;
           margin-bottom: 30px;
           position: relative;
        }
        .bank{        
          display: flex;
          justify-content: space-around;
          align-items: center;
          margin-bottom: 30px;
        }
          .left-content{
            flex:1 1 auto;
              .oi-title{
                  color:#A59BB3;
                  font-size: 26px;
              }
              .oi-content{
                  font-size: 30px;
                  color:#000;
                  margin-top: 10px;
                  &.no-choice{
                      color:#D0CDDA;
                  }
              }
          }
          .right-content{
              flex:0 1 auto;
              position: relative;
              // margin-top: 40px;
          }
          
        .checkbox-container{
              display: flex;
              justify-content: space-around;
              margin: 30px 0;
              color:#333;
              .icon{
                  flex:0 0 auto;
                  margin-right: 20px;
                  margin-left: 0;
              }
              .label-caption{
                  font-size: 24px;
                  color:#777777;
                  line-height: 1.5;
                  color:#333;
                  em{
                      text-decoration: underline;
                      color:#333;
                  }
              }
          }
        }
  
      }
  }
  .order-element {
    width: 654px;
    background: #ffffff;
    box-shadow: 0px 22px 80px 0px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    .tag {
      position: absolute;
      top: 0;
      right: 0;
      width: 194px;
      height: 106px;
      .order_state {
        display: block;
        width: 150px;
        color: #fff;
        font-size: 32px;
        top: 20px;
        right: 0px;
        position: absolute;
        text-align: center;
        transform: rotate(31deg);
      }
    }
    .order-id {
      padding: 30px 40px;
      border-bottom: 2px solid #efeef1;
      color: #fff;
      font-size: 30px;
      height: 46px;
      line-height: 46px;
      background: #5febf3;
      &.red{
        background:#C5340B;
      }      
      font-weight: 700;
    }
    .order-info-list {
      padding: 30px;
      .oi-element {
        overflow: hidden;
        margin-bottom: 30px;
        &.red{
            .left{
                color:#C5340B;
            }                        
        }
        &:last-child {
          margin-bottom: 0;
        }
        .left {
          float: left;
          color: #160544;
          font-size: 32px;
        }
        .right {
          float: right;
          color: #160544;
          font-size: 32px;
        }
      }
    }
  }
  .detail-info {
    background: #f5f4fa;
    padding: 40px;
    width: 564px;    
    margin: -20px auto 0 auto;
    .detail-list {
      margin-top: 60px;
      .detail-list-element {
        overflow: hidden;
        margin-bottom: 30px;
        .left-text {
          float: left;
          color: #a59bb3;
          font-size: 28px;
        }
        .right-text {
          float: right;
          color: #a59bb3;
          font-size: 28px;
        }
      }
    }
  }
  .btn-container {
    position: fixed;
    bottom: 50px;
    left: 0;
    width: 100%;
    height: 96px;
    .btn-submit {
      display: block;
      width: 670px;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 12px;
      background: #5febf3;
      font-size: 32px;
      margin: 0 auto;
      color: #fff;
      &.red{
        background:#C5340B;
      }
    }
  }
  .extension{
    width:640px;
    margin:50px auto;
    font-size: 32px;   
    text-align: center; 
    a{
      text-decoration: underline;
      color:#5febf3;
    }
  }

</style>
<script>
import { orderDetail, repay, getBank,productInfo, beforeReapply } from "@api/index.js";
import { onMounted, reactive,ref } from "vue";
import { useRouter } from "vue-router";
import { useLoading } from 'vue-loading-overlay'
export default {
  setup() {
    const router = useRouter();
    const route = router.currentRoute.value;
    const order_id = ref()
    const loading = useLoading()
    const list_show = ref(false)
    const bank_list_show = ref(false)
    const dialog_confirm_show = ref(false)
    const obj = reactive({
      checked:true,
      reapply:{
        selectAmount:"",
        amountList:[]
      },
      info: {
        id: "",
        loanAmount: "",
        period: "",
        arriveAmount: "",
        repaymentAmount: "",
        loanDate: "",
        gtsFee: "",
        serviceFee: "",
        repaymentDate: "",
        orderNo: "",
        processFee:'', 
        gstFee:'',
        interestFee: '',
        applyTime:'',
        extensionMsg:null,
        reservation:""
      },
    });
    let bank_info = reactive({
          card_no:'',
          bank_id:"",
          have_bank:'',
          list:[]
      })

    const selected_ind = ref("")
    const selected_bank_ind = ref("")
    const selected = async (e, ind) => {
        e.stopPropagation()
        obj.reapply.selectAmount = obj.reapply.amountList[ind]
        selected_ind.value = ind
        list_show.value = false
    }
    const selectedBank = async (e, ind) => {
        e.stopPropagation()
        bank_info.bank_id = bank_info.list[ind].id
        selected_bank_ind.value = ind
        bank_list_show.value = false
    }
    
    const showBankList = () => {
      bank_list_show.value = true
    }
    const showAmountList = () => {
      list_show.value = true
    }
    const confirmShow = () => {
        if(obj.info.reservation == 1) {
          submit()
        } else {
          dialog_confirm_show.value = true
        }        
    }
    const beforeSubmit = async () =>{
      if(obj.checked) {
        const res = await beforeReapply({
            cardId: bank_info.bank_id,
            borrowAmount: obj.reapply.selectAmount,
            orderNo:obj.info.orderNo
        })
        const loader = loading.show({
            "container":null
          })
        if(res.code == 0) {
            loader.hide()
            submit()
        }
      } else {
        submit()
      }
       
    }
    onMounted(async () => {
      document.body.style.background = '#fff'
      order_id.value = route.params.id
      let res = await orderDetail({
        orderId: route.params.id,
      })
      if (res.code == 0) {
        obj.info = {
          arriveAmount: res.data.arriveAmount,
          loanAmount: res.data.loanAmount,
          loanDate: res.data.loanDate,
          overdueDays: res.data.overdueDays,
          gtsFee: res.data.gtsFee,
          serviceFee: res.data.serviceFee,
          repaymentDate: res.data.repaymentDate,
          repaymentAmount: res.data.repaymentAmount,
          period: res.data.period,
          overdueFee: res.data.overdueFee,
          orderState: res.data.orderState,
          orderNo: res.data.orderNo,
          id: res.data.orderId,
          processFee: res.data.serviceFee,
          gstFee: res.data.gstFee,
          interestFee: res.data.interest,
          applyTime:res.data.applyTime,
          extensionMsg:res.data.extensionMsg,
          reservation:res.data.reservation,
          productName:res.data.productName,                   
          extensionState:res.data.extensionState,
          isExtension:res.data.isExtension
        };
      productInfo({
          id: res.data.productId
      }).then(data => {
          obj.reapply.amountList = data.data.amountList
          obj.reapply.selectAmount = data.data.amountList[data.data.amountList.length - 1]
      });
      getBank({
          productId:res.data.productId
      }).then(data3 => {
          if(data3.code == 0) {
              if(data3.data.length > 0) {
                  if(bank_info.bank_id.length) {                      
                      bank_info.list = data3.data
                      bank_info.card_no = bank_info.list[0].cardNo
                      bank_info.bank_id = bank_info.list[0].id
                      
                  } else {
                      bank_info.card_no = data3.data[0].cardNo
                      bank_info.bank_id = data3.data[0].id 
                      bank_info.list = data3.data                       
                  }
                  bank_info.have_bank = true
              } else {
                  bank_info.have_bank = false
              }
          }
      })

      }
    });
    const submit = () => {
        const loader = loading.show({
          "container":null
        })
        repay({
            orderId: obj.info.id
        }).then((res)=>{
            loader.hide()
            if(res.code == 0) {
              if(res.data.paymentUrl.indexOf("?") == -1) {
                window.location.href = res.data.paymentUrl
              } else {
                window.location.href = res.data.paymentUrl + "&callback=https://web3.creditchakrahub.com/"
              }
               
            }
        })
    }
    return {
      obj,
      bank_info,
      list_show,
      bank_list_show,
      dialog_confirm_show,
      submit,
      order_id,
      selected,
      showAmountList,
      showBankList,
      selectedBank,
      beforeSubmit,
      confirmShow,
      selected_ind
    };
  },
};
</script>